import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FilterModel } from '../models';
import { JoinContestModel } from '../models/contest';
import { AppSettings } from '../helpers';

@Injectable()
export class ContestService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    filter(model: FilterModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/contest/filter', model);
    }

    getDetail(id: number) {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/contest/detail?id=' + id);
    }

    getSummary(id: number) {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/contest/summary?id=' + id);
    }

    uploadDesignFile(contestId: number, designFile: any) {
        const formData: FormData = new FormData();
        formData.append('contestId', contestId.toString());
        formData.append('designFile', designFile);

        return this.http.post(this.appSettings.ApiBaseUrl + '/api/contest/upload-design',
            formData);
    }

    submitContest(model: JoinContestModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/contest/submit', model);
    }

    getSubmissionsSummary(contestId: number) {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/contest/get-submissions-summary?contestId=' + contestId);
    }

    getSubmissionsByGalleryId(galleryId: any) {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/contest/get-submissions-by-gallery-id?galleryId=' + galleryId);
    }
}



// WEBPACK FOOTER //
// ./src/services/contest.service.ts